// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/components/confirmation-modal/confirmation-modal.less
// module id = 3174
// module chunks = 0